<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Edit Device</h2>
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <EditDeviceForm :device_id="device_id"></EditDeviceForm>
      </div>
      <div class="col-4">
        <CurrentExtensions default_type="device"></CurrentExtensions>
      </div>
    </div>
  </div>
</template>

<script>
import CurrentExtensions from '../../components/CurrentExtensions'
import EditDeviceForm from '../../components/Device/EditDeviceForm.vue'

export default {
  props: ['device_id'],
  components: { CurrentExtensions, EditDeviceForm }
}
</script>

<style scoped>
</style>
